<template lang="pug">
.footer
	.item
		.title {{langs[lang].contact}}
		hr
		.content
			.address
				.line
					span.iconfont &#xe62e;
					.addr {{langs[lang].addressBeijing}}
				.line
					span.iconfont &#xe604;
					| +86 10 6563 0026
			.address
				.line
					span.iconfont &#xe62e;
					.addr {{langs[lang].addressShanghai}}
				.line
					span.iconfont &#xe604;
					| +86 21 6418 7585
	.item
		.title {{langs[lang].follow}}
		hr
		.content
			.line
				span.iconfont &#xe62b;
				| {{langs[lang].bp}}
				br
				| bp@bertelsmann.com
			.line
				span.iconfont &#xe621;
				| {{langs[lang].join}}
				br
				| hr@bertelsmann.com
	//- .item.qrcode
	//- 	.title {{langs[lang].more}}
	//- 	hr
	//- 	.content
	//- 		a(href="http://www.bertelsmann.com.cn/") {{langs[lang].baiChina}}
	//- 		a(href="https://www.bertelsmann.com/#st-1") {{langs[lang].baiSE}}
	//- 		img(src="../assets/contact/weixin_qrcode.jpg")
</template>

<script>
const Footer = {
  props: [],
  data() {
    return {
      langs: {
        zh: {
          baiChina: "贝塔斯曼中国总部",
          baiSE: "贝塔斯曼集团总部",
          contact: "地址",
          follow: "合作",
          more: "更多",
          addressBeijing: "北京市朝阳区新源南路8号启皓北京西塔16层1609室",
          postBeijing: "邮编100027",
          addressShanghai: "上海市徐汇区永嘉路750号4楼",
          postShanghai: "邮编200031",
          join: "加入我们",
          bp: "商业计划书",
        },
        en: {
          baiChina: "Bertelsmann China Corporate Center",
          baiSE: "Bertelsmann SE& Co.KGaA",
          contact: "Locations",
          follow: "Cooperation",
          more: "More",
          addressBeijing:
            "Unit 1609, 16F, West Tower, Genesis Beijing, 8 Xinyuan South Rd., Chaoyang District, Beijing。",
          postBeijing: "Beijing 100027, P.R.China",
          addressShanghai: "4F, 750 Yongjia Rd. Xuhui District, Shanghai",
          postShanghai: "Shanghai 200031, PR China",
          join: "join us",
          bp: "BP",
        },
      },
      mapBeijing: null,
      mapShanghai: null,
    };
  },
  mounted() {
    this.mapBeijing = new window.AMap.Map("map", {
      center: [116.4561, 39.9476],
      scrollWheel: false,
      zoom: 16,
    });
    this.mapShanghai = new window.AMap.Map("map", {
      center: [121.446711, 31.204105],
      scrollWheel: false,
      zoom: 16,
    });
    const markerBeijing = new window.AMap.Marker({
      position: [116.4561, 39.9476],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.mapBeijing,
    });
    const markerShanghai = new window.AMap.Marker({
      position: [121.446711, 31.204105],
      offset: new window.AMap.Pixel(-12, -12),
      map: this.mapShanghai,
    });
    console.log(
      "markerBeijing, markerShanghai:",
      markerBeijing,
      markerShanghai
    );
  },
  components: {},
  computed: {
    lang() {
      return localStorage.lang;
    },
  },
  methods: {},
};
export default Footer;
</script>

<style scoped lang="stylus">
.title{
	font-weight: bold;
}
.iconfont{
	font-weight: bold;
	color: #02284f;
}
@media (max-width: 720px) {
	.footer{
	 	height: 2400px;
		margin-top: 20px;
		overflow: scroll;
	  .logo{
	   	display: none;
	  }
		hr{
			border-color: #e7e7e7;
			margin: 30px 0;
		}
		.item{
			margin-top: 30px;
			font-size: 14px;/*no*/
			line-height: 2;
			margin-right: 30px;
			&.qrcode{
				margin-bottom 50px
			}
			.line{
				overflow: hidden;
				margin-bottom: 20px;
				.iconfont{
					width: 5%;
					position: relative;
					top: 2px;
					float: left;
					margin-right: 5%;
				}
				.addr{
					float: left;
					width: 90%;
				}
			}
			.content{
				overflow: hidden;
			}
			.half{
				width: 100%;
				box-sizing: border-box;
				margin-bottom: 30px;
				border-bottom: 1px solid #e6e6e6
				padding-bottom: 50px;
				padding-right: 5%;
				float: left;
				line-height: 1.5;
				#map-beijing, #map-shanghai{
					width: 100%;
					height: 800px;
					margin-bottom: 30px;
				}
				.address{
					height: 120px;
					margin-bottom: 40px;
				}
				.post-no{
					padding-left: 80px;
				}
				.iconfont{
					margin-right: 10px
					display: inline-block;
					float: left;
					height: 200px;
				}
			}
			img{
				width: 60%;
				margin: 30px auto 0;
			}
		}
		a{
			display: block;
			line-height: 2;
			color: #02284f;
			font-weight: bold;
			text-decoration: none;
		}
	}
}
@media (min-width: 720px) {
.footer{
  height: auto
	margin: 0 auto;
	width: 987px;
	display: flex;
  .logo{
    width: 330px;
    height: 81px;
		margin: 60px 30px 0 60px;
		flex: 0 0 auto;
  }
	hr{
		border-color: #e7e7e7;
		margin: 11px 0 22px;
	}
	.item{
		flex: 1 1 auto;
		width: 329px;
		font-size: 20px;
		margin-right: 30px;
		.address{
			height: 60px;
			margin-bottom: 100px;
		}
		.post-no{
			padding-left: 30px;
		}
		.iconfont{
			margin-right: 10px;
			height: 40px;
			float: left;
			clear: left;
		}
		.line{
			overflow: hidden;
			float: left;
			width: 100%;
			margin-bottom: 20px;
			.iconfont{
				width: 5%;
				position: relative;
				top: 2px;
			}
			.addr{
				width: 95%;
			}
		}
		img{
			margin-top: 30px;
			width: 200px;
		}
		a{
			display: block;
			line-height: 2;
			color: #000;
			text-decoration: none;
		}
	}
}
}
</style>



// WEBPACK FOOTER //
// footer.vue?5243701b